<template>
    <NotFound>
        <div class="mb-3">
            Nech hľadám ako hľadám,
            <span class="font-semibold">{{ searchTerm }}</span> som nenašiel.
        </div>

        <ul class="ml-4 list-outside list-disc">
            <li>Skús hľadať pod iným názvom.</li>
            <li>Skús hľadať pod všeobecnejším názvom.</li>
            <li>Uisti sa, či si napísal všetko správne.</li>
        </ul>
    </NotFound>
</template>

<script setup lang="ts">
import NotFound from '@/components/common/NotFound.vue'

defineProps({
    searchTerm: {
        type: String,
        required: true
    }
})
</script>
